import api from '../../lib/api';
import endpoints from '../../lib/endpoints';
import sortBy from 'lodash/sortBy';
import isEmpty from 'lodash/isEmpty';

export const processArray = async arr => {
  const asyncResult = [];

  await arr.forEach(async ({ booking_type, booking_id }) => {
    try {
      const url = endpoints.getBookingDetails(booking_type, booking_id);
      const { data } = await api.getWithToken(url);
      asyncResult.push(data);
      return asyncResult;
    } catch (err) {
      throw err;
    }
  });
};

export const sortByStartDate = data =>
  sortBy(data, [
    function(trek) {
      return trek.start_date;
    },
  ]);

export const modifyChatLinks = chatLinks => {
  let modifiedChatLinks = {};

  CHAT_LINKS.forEach(link => {
    const platform = chatLinks.filter(chatLink => chatLink.platform === link.patch_key)[0];

    modifiedChatLinks[link.patch_key] = {
      link: platform ? makeLinks(platform) : '',
      platform: link.patch_key,
    };
  });
  return modifiedChatLinks;
};

function makeLinks(platformObj) {
  const { link } = platformObj;

  if (link) {
    if (link.startsWith('http')) {
      return link;
    } else {
      return `http://${link}`;
    }
  }
}

export const CHAT_LINKS = [
  {
    title: 'Facebook',
    patch_key: 'facebook',
    icon: 'icon icon-hg-facebook-square',
  },
  {
    title: 'Instagram',
    patch_key: 'instagram',
    icon: 'icon icon-hg-instagram-1',
  },
  {
    title: 'Youtube',
    patch_key: 'youtube',
    icon: 'icon icon-hg-youtube-logo',
  },
  {
    title: 'Whatsapp Number',
    patch_key: 'whatsapp',
    icon: 'icon icon-hg-whatsapp',
  },
  {
    title: 'Viber Number',
    patch_key: 'viber',
    icon: 'icon icon-hg-viber',
  },
  {
    title: 'Website',
    patch_key: 'website',
    icon: 'icon icon-hg-internet',
  },
];

export const GUIDE_PROFILE_KEYS = [
  {
    title: 'Email Address',
    key: 'email_address',
  },
  {
    title: 'Chat Platform Links',
    key: 'chat_platform_links',
  },
  {
    title: 'Contact Info',
    key: 'phone_numbers',
  },
  {
    title: 'Daily Wages (USD per day)',
    key: 'daily_wages',
  },
  {
    title: 'Experience (in Years)',
    key: 'experience_years',
  },
  {
    title: 'Safety Trainings',
    key: 'safety_trainings',
  },
  {
    title: 'Languages',
    key: 'languages',
  },
  {
    title: 'Specialization',
    key: 'specialization',
  },
  {
    title: 'Expertise Regions',
    key: 'expertise_regions',
  },
];

export function getUsableLink(url, platform) {
  if (!url) return '';

  const viberLink = 'viber://chat?number=';
  const whatsAppLink = 'https://api.whatsapp.com/send?phone=';

  if (platform === 'viber') {
    return viberLink + url;
  } else if (platform === 'whatsapp') {
    return whatsAppLink + url;
  } else {
    return url;
  }
}

export const joinArray = array => (!isEmpty(array) ? array.join(',') : '');



// WEBPACK FOOTER //
// ./src/components/Profile/utils.js